<template>
  <!-- テキスト部分のみ縁取りを適用（絵文字はそのまま） -->
  <p class="caption-text-wrapper" :style="{ fontSize: `${props.fontSize}px` }">
    <template v-for="(part, index) in splitCaption" :key="index">
      <span v-if="part.type === 'text'" class="text" :style="[captionShadowColor]">{{
        part.content
      }}</span>
      <span v-else>{{ part.content }}</span>
    </template>
  </p>
</template>

<script setup>
import { computed } from 'vue';
import { splitByEmoji } from '@/composable/content_common';

const props = defineProps({
  fontSize: Number,
  contentCaption: String,
  contentCaptionShadowColor: String,
});

const splitCaption = computed(() => {
  return props.contentCaption ? splitByEmoji(props.contentCaption) : [];
});

const captionShadowColor = computed(() => {
  return {
    '--caption-shadow-color': props.contentCaptionShadowColor,
  };
});
</script>

<style scoped>
.caption-text-wrapper {
  display: flex;
  align-items: center;
  height: fit-content;
}
.text {
  text-shadow: -0.3px 0 var(--caption-shadow-color), 0 0.3px var(--caption-shadow-color),
    0.3px 0 var(--caption-shadow-color), 0 -0.3px var(--caption-shadow-color);
}
</style>
